import React, { useEffect } from 'react';
import { format, subDays } from 'date-fns';
import { trackVisit } from '../services/visitTrackingService';
import SEO from '../components/SEO'; // Import SEO component
import Footer from '../components/Footer';
import MemberWelcomeBar from '../components/home/MemberWelcomeBar';
import HeroSection from '../components/home/sections/HeroSection';
import FeaturesSection from '../components/home/sections/FeaturesSection';
import ProfilesSection from '../components/home/sections/ProfilesSection';
import QRPlateSection from '../components/home/sections/QRPlateSection';
import DemoSection from '../components/home/sections/DemoSection';
import LongevitySection from '../components/home/sections/LongevitySection';
import HowItWorksSection from '../components/home/sections/HowItWorksSection';
import './Home.css';

const Home = () => {
  // Homepage preview data is intentionally static. Loading /api/profiles/P1a2b here
  // would count Mira as viewed even when the visitor never opened her profile.
  const profiles = [{
    id: 'P1a2b',
    stringId: 'P1a2b',
    name: 'Мира Стојковска',
    birthDate: '15.03.1941',
    deathDate: format(subDays(new Date(), 10), 'dd.MM.yyyy'),
    introduction: 'Мира беше прекрасна жена со добра душа. Посветена мајка, омилена баба и личност што ги допираше срцата на сите околу неа со својата топлина, мудрост и љубов.',
    restingPlaceCity: 'Скопје',
    uploadedImages: [
      'https://img.spomen.mk/spomenmk/demo/1.png?v=20260809',
      'https://img.spomen.mk/spomenmk/demo/2.png?v=20260809',
      'https://img.spomen.mk/spomenmk/demo/3.png?v=20260809',
      'https://img.spomen.mk/spomenmk/demo/4.png?v=20260809',
      'https://img.spomen.mk/spomenmk/demo/5.png?v=20260809',
      'https://img.spomen.mk/spomenmk/demo/6.png?v=20260809'
    ].map((url, index) => ({ id: `mira-preview-${index}`, url }))
  }];

  useEffect(() => {
    // Track home page visit
    trackVisit('HOME');

  }, []);

  return (
    <div className="app">
      <SEO page="home" />
      <main className="main-content">
        <MemberWelcomeBar />
        <section id="hero">
          <HeroSection />
        </section>
        <section id="how-it-works">
          <HowItWorksSection />
        </section>
        <section id="profiles">
          <ProfilesSection profiles={profiles} loading={false} error={null} />
        </section>
        <section id="qr-plate">
          <QRPlateSection />
        </section>
        <section id="features">
          <FeaturesSection />
        </section>
        <section id="longevity">
          <LongevitySection />
        </section>
        <section id="demo">
          <DemoSection />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Home;
